module.exports = __webpack_public_path__ + "images/icons/icon-logout-8372e668.svg";